import { Box, Typography } from "@mui/material";
import React from "react";

export default function HeaderSection({ title }) {
    return (
        <Box
            sx={{
                mb: 3,
                textAlign: "center",
            }}
        >
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                }}
            >
                <img
                    src="/static/reportCrop.png"
                    alt="Header Graphic"
                    style={{
                        width: "100%",
                        borderRadius: "10px",
                        objectFit: "contain",
                    }}
                />
            </Box>
        </Box>
    );
}
